/* eslint-disable */
<template>
    <div class="d-flex flex-column justify-content-center align-items-center h-100 mt-5 px-4">
        <div class="font-size-h3 text-default text-center">
            <span>Thanks for accepting the new date! Your appointment is confirmed for</span>
            <span class="font-weight-bold"> {{formattedStartDay}}, {{formattedStartDate}} at {{formattedStartTime}}. </span>
            <span>An email confirmation will be sent to you shortly.</span>
        </div>
    </div>
</template>

<script>
/* eslint-disable */
    import moment from 'moment-timezone'
    import { mapState } from 'vuex'
    import { DateFormatMixin } from '@/mixins/Booking/DateFormatMixin';
    import { TimeFormatMixin } from '@/mixins/Booking/TimeFormatMixin';
  
    export default {
        name: 'DisplayedApproved',
        mixins: [DateFormatMixin, TimeFormatMixin],
        computed: {
            ...mapState('BookingUpload', [
                'startUtc'
            ]),
            ...mapState('TimeZone', [
                'selectedTimeZoneId'
            ]),
            formattedStartUtc() {
                if (!!this.startUtc) {
                    return moment.utc(this.startUtc).clone().tz(this.selectedTimeZoneId)
                }
            },
            formattedStartDay(){ 
                return this.formattedStartUtc ? this.formattedStartUtc.format('dddd') : "";
            },
            formattedStartDate(){ 
                return this.formattedStartUtc ? this.formattedStartUtc.format(this.momentJSDateFormat) : "";
            },
            formattedStartTime() {
                return this.formattedStartUtc ? this.formattedStartUtc.format(this.momentJSTimeFormat) : "";
            }
        }
    }
</script>